import React from 'react';
import { StopCircle } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectVendorData } from './store/selectors';
import { selectStatuses } from '../../core/redux/status/selectors';
import { selectVendorFilters } from './store/selectors';
import { actions as vendorActions, fetchVendorsWithFilters } from './store/slice';
import { useTransformOptions } from 'Core/hooks';

const { setVendor, setStatus } = vendorActions;

const VendorFilter = () => {
  const dispatch = useDispatch();
  const vendors = useSelector(selectVendorData);
  const statuses = useSelector(selectStatuses);
  const {
    vendor: selectedVendor,
    status: selectedStatus,
  } = useSelector(selectVendorFilters);

  const vendorOptions = useTransformOptions(
    vendors,
    'id',
    'vendorName',
    '0',
    'Select Vendor',
  );
  const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const handleVendorChange = selected => {
    dispatch(setVendor(selected));
  };

  const handleStatusChange = selected => {
    dispatch(setStatus(selected));
  };

  const onSearch = () => {
    dispatch(fetchVendorsWithFilters());
  };

  return (
    <div className="card mb-0">
      <div className="card-body">
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>Vendor</label>
              <Select
                value={selectedVendor}
                onChange={handleVendorChange}
                options={vendorOptions}
                className="select"
                placeholder="Select Vendor"
                isClearable={true}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Status</label>
              <Select
                value={selectedStatus}
                onChange={handleStatusChange}
                options={statusOptions}
                className="select"
                placeholder="Select Status"
                isClearable={true}
              />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>&nbsp;</label>
              <button className="btn btn-primary w-100" onClick={onSearch}>
                <StopCircle className="me-1" />
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorFilter; 